import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useFormik} from 'formik';

import {useToast} from '@components/_context/ToastContext';

import {ResetPasswordForm} from './ResetPasswordForm';
import {submitForm, validateSchema} from './ResetPasswordForm.controller';

export const ResetPasswordFormView = ({onSubmit = () => {}}) => {
  const intl = useIntl();
  const toast = useToast();
  const formik = useFormik({
    initialValues: {password: '', repeatPassword: ''},
    onSubmit: submitForm({toast, formatMessage: intl.formatMessage, onSubmit}),
    validationSchema: validateSchema({intl}),
  });
  return <ResetPasswordForm {...formik} />;
};

ResetPasswordFormView.propTypes = {
  onSubmit: PropTypes.func,
};
